import { Injectable } from '@angular/core';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { AuthService } from '@core/auth/services/auth.service';
import { RoleService } from './role.service';
import { RolePermissionMatrix } from '../models/role.model';
import { PermissionRefreshService } from '../permissions/permission-refresh.service';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionsService {

  constructor(
    private ngxPermissionsService: NgxPermissionsService,
    private ngxRolesService: NgxRolesService,
    private authService: AuthService,
    private roleService: RoleService,
    private permissionRefreshService: PermissionRefreshService
  ) {
    this.permissionRefreshService.refresh$.subscribe(() => {
      this.initializePermissions();
    });
  }

  initializePermissions(): void {
    const userData = this.authService.getUserData();

    if (!userData || userData.role === undefined || userData.role === null) {
      this.clearPermissions();
      return;
    }

    // this.roleService.getRolePermissionMatrix().subscribe({
    //   next: (matrix: RolePermissionMatrix) => {
    //     this.setUserPermissions(userData.role, matrix);
    //   },
    //   error: (error) => {
    //     this.clearPermissions();
    //   }
    // });
  }

  private setUserPermissions(userRoleId: number, matrix: RolePermissionMatrix): void {
    this.clearPermissions();


    const userRolePermissions = matrix.rolePermissions.filter(rp => rp.roleId === userRoleId && rp.granted);

    const userPermissions = userRolePermissions
      .map(rp => {
        const permission = matrix.permissions.find(p => Number(p.id) === rp.permissionId);
        return permission ? permission.route : null;
      })
      .filter(route => route !== null) as string[];

    this.ngxPermissionsService.loadPermissions(userPermissions);

    const role = matrix.roles.find(r => Number(r.id) === userRoleId);
    if (role) {
      this.ngxRolesService.addRole(role.name, userPermissions);
    }

  }

  clearPermissions(): void {
    this.ngxPermissionsService.flushPermissions();
    this.ngxRolesService.flushRoles();
  }
  
  hasPermission(route: string): boolean {
    return this.ngxPermissionsService.getPermission(route) !== undefined;
  }

  getCurrentPermissions(): string[] {
    const permissions = this.ngxPermissionsService.getPermissions();
    return Object.keys(permissions);
  }

  hasRouteAccess(route: string): boolean {
    const userData = this.authService.getUserData();
    if (!userData || !userData.role) {
      return false;
    }


    if (userData.role === 0) {
      return true;
    }


    return this.hasPermission(route);
  }

  getCurrentUserRoleName(): string {
    const userData = this.authService.getUserData();
    if (!userData || !userData.role) {
      return 'Unknown';
    }
    return this.roleService.getRoleName(userData.role);
  }

  refreshPermissions(): void {
    this.initializePermissions();
  }

  addPermission(permission: string): void {
    this.ngxPermissionsService.addPermission(permission);
  }

  removePermission(permission: string): void {
    this.ngxPermissionsService.removePermission(permission);
  }
}
